import React from 'react';
import MyProperty from './propertylandingpage';

function App() {
  return (
    <div className="App">
      <MyProperty />
    </div>
  );
}

export default App;
